import { FC, useCallback, useEffect, useRef, useState } from "react";
import {
  Card,
  Row,
  Col,
  Input,
  Button,
  Typography,
  Table,
  Tag,
  Radio,
  Modal,
  Spin,
  Form,
  Flex,
  Badge,
  Select,
  Progress,
  Tooltip,
} from "antd";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../../utils/notificationUtils";
import {
  getCaptcha,
  getLiveScreen,
  portalsLogin,
  portalsLoginRetry,
  portalsLogout,
  portalsSaveOtp,
} from "../../../apis/authService";
import {
  AppstoreOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
  LockOutlined,
  LoginOutlined,
  ReloadOutlined,
  SwapOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import {
  fetchLoginHistory,
  fetchPortalDataForCGHSNewForEODBOD,
  fetchPortalDataForEchsForEODBOD,
  fetchPortalDataForAyushmanBharatForEODBOD,
  fetchProcessHistory,
  getLastLoginHistory,
} from "../../../apis/reconciliationService";
import LoginHistoryModal from "./LoginHistoryModal";
import { API_URL } from "../../../utils/constants";
import { getSchemeDisplayName } from "../../../utils/schemeDisplay";
import { errorMessageModal } from "../../../utils/modalMessage";

const { Text } = Typography;

interface FetchSchemeActionsProps {
  selectedScheme: number | null;
  availableSchemes: any;
  selectedPortal: any;
  handleSchemeChange: any;
  selectedSchemeName: string;
  handleSummaryClicked: (record: any) => void;
  handleViewMoreClick: () => void;
  selectedHospital: number | null;
  bodEod: any;
  selectedDate: any;
  initialEODBODConfig: any;
  getInitialEODBODConfig: any;
}

const FetchSchemeActions: FC<FetchSchemeActionsProps> = ({
  availableSchemes,
  selectedScheme,
  selectedPortal,
  handleSchemeChange,
  selectedSchemeName,
  handleSummaryClicked,
  handleViewMoreClick,
  selectedHospital,
  bodEod,
  selectedDate,
  initialEODBODConfig,
  getInitialEODBODConfig,
}) => {
  const [echsPortalUrl, setEchsPortalUrl] = useState<any>(null);
  const echsPortalUrlRef = useRef(null);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [isCaptchaLoading, setIsCaptchaLoading] = useState<boolean>(false);
  const [fetchType, setFetchType] = useState<string>("all");
  const [isLiveScreenModalOpen, setIsLiveScreenModalOpen] = useState(false);
  const [liveScreenUrl, setLiveScreenUrl] = useState<any>(null);
  const [isLiveScreenLoading, setIsLiveScreenLoading] = useState(false);
  const [captchaCodeText1, setCaptchaCodeText1] = useState<any>(null);
  const [captchaCodeText2, setCaptchaCodeText2] = useState<any>(null);
  const [captchaImageUrl, setCaptchaImageUrl] = useState<any>(null);
  const [captchaImageUrl2, setCaptchaImageUrl2] = useState<any>(null);
  const [isLoggedInLoading, setIsLoggedInLoading] = useState<boolean>(false);
  const [isLoggedOutLoading, setIsLoggedOutLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [statusLogin, setStatusLogin] = useState<string>("");
  const [showLoginButton, setShowLoginButton] = useState<boolean>(true);
  const [isOtpLoading, setIsOtpLoading] = useState<boolean>(false);
  const [showOtpField, setShowOtpField] = useState<boolean>(false);
  const [mobileNumber, setMobileNumber] = useState<string>("");
  const [phoneNumbers, setPhoneNumbers] = useState<string[]>([]);
  const [isFetchPortalDataLoading, setIsFetchPortalDataLoading] =
    useState<boolean>(false);
  const [fetchPortalDataApiMessage, setFetchPortalDataApiMessage] = useState<
    string | null
  >(null);
  const [fetchPortalDataApiMessageStatus, setFetchPortalDataApiMessageStatus] =
    useState<string | null>(null);
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const [processHistoryData, setProcessHistoryData] = useState<any>([]);
  const [isProcessHistoryLoading, setIsProcessHistoryLoading] =
    useState<boolean>(false);
  const [openLoginHistoryModal, setOpenLoginHistoryModal] =
    useState<boolean>(false);
  const [isLoginHistoryModalDataLoading, setIsLoginHistoryModalDataLoading] =
    useState<boolean>(false);
  const [loginHistoryModalData, setloginHistoryModalData] = useState<any[]>([]);
  const [loginHistoryDataTotal, setLoginHistoryDataTotal] = useState<number>(0);
  const [isRefreshLoading, setIsRefreshLoading] = useState<boolean>(false);
  const [fetchActivityId, setFetchActivityId] = useState<number | null>(null);
  const [isSessionAlreadyLogin, setIsSessionAlreadyLogin] =
    useState<boolean>(false);
  const [isRetryLoading, setIsRetryLoading] = useState(false);
  const [lastLoginHistoryData, setLastLoginHistoryData] = useState<any[]>([]);
  const [isLastLoginHistoryLoading, setIsLastLoginHistoryLoading] =
    useState<boolean>(false);
  const [showLoginPortal, setShowLoginPortal] = useState<boolean>(false);

  const onRefreshClick = async () => {
    try {
      setIsRefreshLoading(true);

      setProcessHistoryPagination((prev) => ({
        ...prev,
        current: 1,
      }));

      await getProcessHistory(1, processHistoryPagination.pageSize);
    } catch (err) {
      errorMessage("Failed to refresh data");
    } finally {
      setIsRefreshLoading(false);
    }
  };

  const handleMobileChange = (value: string) => setMobileNumber(value);

  const [processHistoryPagination, setProcessHistoryPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [processHistoryTotal, setProcessHistoryTotal] = useState<number>(0);

  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    await handleSaveOtp(values, captchaCodeText2);
    form.resetFields();
  };

  enum SchemName {
    CGHS = "CGHS",
    CGHS_NEW = "CGHS NEW",
    ECHS = "ECHS",
    AYUSHMAN_BHARAT = "AYUSHMAN BHARAT",
  }

  const resetData = useCallback(() => {
    setCaptchaCodeText1(null);
    setCaptchaImageUrl(null);
    setShowOtpField(false);
    setShowLoginButton(true);
    setMessage("");
    setStatusLogin("");
    setMobileNumber("");
    setPhoneNumbers([]);
    setCaptchaCodeText2(null);
    setCaptchaImageUrl2(null);
    setShowCaptcha(false);
    setIsSessionAlreadyLogin(false);
  }, []);

  useEffect(() => {
    setShowOtpField(false);
    setShowLoginButton(true);
    setMessage("");
    setStatusLogin("");
    setCaptchaCodeText1(null);
    setCaptchaImageUrl(null);
    setCaptchaCodeText2("");
    setCaptchaImageUrl2(null);
    setMobileNumber("");
    setPhoneNumbers([]);
    setIsLoggedOut(false);
    setIsSessionAlreadyLogin(false);
    setShowLoginPortal(false);
  }, [selectedScheme]);

  useEffect(() => {
    if (
      selectedSchemeName === SchemName.AYUSHMAN_BHARAT ||
      selectedSchemeName === SchemName.CGHS_NEW
    ) {
      setShowCaptcha(true);
    }
    setEchsPortalUrl(null);
    echsPortalUrlRef.current = null;
    setIsSessionAlreadyLogin(false);
  }, [selectedSchemeName]);

  useEffect(() => {
    if (selectedHospital && bodEod) {
      getProcessHistory();
    } else {
      setProcessHistoryData([]);
      setProcessHistoryTotal(0);
    }
  }, [selectedHospital, bodEod]);

  useEffect(() => {
    if (!selectedHospital || !bodEod || !selectedScheme) {
      setLastLoginHistoryData([]);
      return;
    }

    (async () => {
      try {
        setIsLastLoginHistoryLoading(true);
        const response = await getLastLoginHistory({
          hospitalId: selectedHospital,
          schemeIds: [selectedScheme],
        });
        setLastLoginHistoryData(response?.data?.data || response?.data || []);
      } catch (error) {
        setLastLoginHistoryData([]);
      } finally {
        setIsLastLoginHistoryLoading(false);
      }
    })();
  }, [selectedHospital, bodEod, selectedScheme]);

  const handleSaveLogin = useCallback(async () => {
    if (!selectedHospital || !selectedScheme) {
      warningMessage("Please Select Hospital and Scheme");
      return;
    }
    try {
      setMessage("");
      setIsLoggedInLoading(true);
      warningMessage("Login is in progress");
      if (selectedSchemeName?.toUpperCase() === "CGHS") {
        setTimeout(() => {
          setShowOtpField(true);
        }, 12000);
      }
      const data = {
        schemeId: selectedScheme,
        hospitalId: selectedHospital,
        captchaCode: captchaCodeText1,
        ...((selectedSchemeName === SchemName.AYUSHMAN_BHARAT ||
          selectedSchemeName === SchemName.CGHS_NEW) &&
        !showOtpField &&
        mobileNumber
          ? { mobileNumber }
          : {}),
        ...(selectedSchemeName === SchemName.ECHS && {
          portalUrl: echsPortalUrlRef.current,
        }),
        portalLoginEodBodRequest: {
          eodBodProcessType: bodEod,
          targetDate: selectedDate.startOf().format("YYYY-MM-DDTHH:mm:ss.SSS"),
        },
      };
      const res = await portalsLogin(data, selectedPortal);
      setIsLoggedInLoading(false);
      if (res) {
        setShowOtpField(!!res.otpRequired);
        setShowLoginButton(false);

        if (
          selectedSchemeName === SchemName.AYUSHMAN_BHARAT &&
          res.otpRequired
        ) {
          setCaptchaImageUrl2(res?.secondCaptchaImage || res?.captcha || null);
        }

        if (selectedSchemeName === SchemName.CGHS_NEW && res.otpRequired) {
          setCaptchaImageUrl2(res?.secondCaptchaImage || res?.captcha || null);
        }

        if (
          (selectedSchemeName === SchemName.CGHS &&
            res.status?.toUpperCase() === "REJECTED") ||
          res.status?.toUpperCase() === "PENDING"
        ) {
          setMessage("");
        }

        if (
          selectedSchemeName === SchemName.AYUSHMAN_BHARAT &&
          !res.otpRequired &&
          res.status?.toUpperCase() === "REJECTED"
        ) {
          setCaptchaCodeText1("");
          setShowLoginButton(true);
          setCaptchaImageUrl(res?.captcha);
          setCaptchaCodeText2("");
          setMessage(res?.message || "");
        }

        if (
          selectedSchemeName === SchemName.CGHS_NEW &&
          !res.otpRequired &&
          res.status?.toUpperCase() === "REJECTED"
        ) {
          setCaptchaCodeText1("");
          setShowLoginButton(true);
          setCaptchaImageUrl(res?.captcha);
          setCaptchaCodeText2("");
          setMessage(res?.message || "");
        }

        if (!res.otpRequired) {
          setMessage(res.message || "");
          setStatusLogin(res.status || "");
        }

        if (res.status?.toUpperCase() !== "REJECTED") {
          successMessage("Logged In Successfully");
          getInitialEODBODConfig();
        }
      } else if (selectedSchemeName === SchemName.CGHS_NEW) {
        setStatusLogin("Success");
        setShowLoginButton(false);
      }
    } catch (err: any) {
      errorMessageModal(err?.message || "Please, Try again later");
      setIsLoggedInLoading(false);
      setShowLoginButton(true);
      setShowOtpField(false);
    }
  }, [
    captchaCodeText1,
    mobileNumber,
    showOtpField,
    selectedHospital,
    selectedPortal,
    selectedScheme,
    selectedSchemeName,
    bodEod,
    selectedDate,
    getInitialEODBODConfig,
  ]);

  const handleLogout = useCallback(async () => {
    if (!selectedHospital || !selectedScheme) {
      warningMessage("Please Select Hospital and Scheme");
      return;
    }
    try {
      const data = {
        schemeId: selectedScheme,
        hospitalId: selectedHospital,
      };
      setIsLoggedOutLoading(true);
      const res = await portalsLogout(data, selectedPortal);
      setIsLoggedOutLoading(false);
      successMessage(res?.message || "Logout done successfully");
      resetData();
      setIsLoggedOut(true);
      // ECHS: URL stays selected after logout/retry, so Radio onChange won't fire —
      // reload captcha automatically when portal URL is already chosen
      if (selectedSchemeName === SchemName.ECHS && echsPortalUrlRef.current) {
        setShowCaptcha(true);
        fetchCaptcha();
      }
    } catch (err: any) {
      errorMessageModal(err?.message || "Please, Try again later");
      setIsLoggedOutLoading(false);
    }
  }, [selectedHospital, selectedScheme]);

  const handleSaveOtp = useCallback(
    async (values: any, currentCaptchaCode2: any) => {
      if (!selectedHospital || !selectedScheme) {
        warningMessage("Please Select Hospital and Scheme");
        return;
      }
      try {
        const data = {
          schemeId: selectedScheme,
          hospitalId: selectedHospital,
          otp: values?.otp,
          captchaCode: currentCaptchaCode2,
          ...((selectedSchemeName === SchemName.AYUSHMAN_BHARAT ||
            selectedSchemeName === SchemName.CGHS_NEW) &&
          mobileNumber
            ? { mobileNumber }
            : {}),
          portalLoginEodBodRequest: {
            eodBodProcessType: bodEod,
            targetDate: selectedDate
              .startOf()
              .format("YYYY-MM-DDTHH:mm:ss.SSS"),
          },
        };
        setIsOtpLoading(true);
        const res = await portalsSaveOtp(data, selectedPortal);
        setIsOtpLoading(false);
        if (
          selectedSchemeName === SchemName.AYUSHMAN_BHARAT &&
          res.status?.toUpperCase() === "REJECTED"
        ) {
          setCaptchaCodeText2("");
          setCaptchaImageUrl2(res?.captcha);
        }

        // CGHS NEW only: session logged out / re-login — keep phone, reuse captcha from API
        if (
          selectedSchemeName === SchemName.CGHS_NEW &&
          res.status?.toUpperCase() === "REJECTED"
        ) {
          if (!res.otpRequired && res?.captcha) {
            setShowOtpField(false);
            setShowLoginButton(true);
            setShowCaptcha(true);
            setCaptchaCodeText1("");
            setCaptchaImageUrl(res.captcha);
            setCaptchaCodeText2("");
            setCaptchaImageUrl2(null);
          } else {
            setCaptchaCodeText2("");
            setCaptchaImageUrl2(res?.captcha);
          }
        }

        if (res.status?.toUpperCase() !== "REJECTED") {
          setShowCaptcha(false);
          setCaptchaImageUrl(null);
          successMessage("OTP submitted successfully");
          setShowOtpField(false);
          getInitialEODBODConfig();
        }
        setMessage(res.message || "");
        setStatusLogin(res.status || "");
      } catch (err: any) {
        errorMessageModal(err?.message || "Please, Try again later");
        setIsOtpLoading(false);
      }
    },
    [selectedHospital, selectedScheme, selectedSchemeName, mobileNumber],
  );

  const handleLoginRetry = async () => {
    if (!selectedHospital || !selectedScheme) {
      warningMessage("Please Select Hospital and Scheme");
      return;
    }
    try {
      setIsRetryLoading(true);
      const data = {
        schemeId: selectedScheme,
        hospitalId: selectedHospital,
      };
      const res = await portalsLoginRetry(data);

      setShowOtpField(false);
      setCaptchaCodeText1(null);
      setCaptchaCodeText2("");
      setCaptchaImageUrl2(null);

      const captchaValue = res?.captcha;
      const isAlreadyLoggedIn =
        typeof captchaValue === "string" &&
        captchaValue.toLowerCase().includes("session is already login");

      if (isAlreadyLoggedIn) {
        setIsSessionAlreadyLogin(true);
        setCaptchaImageUrl(null);
        setMessage(captchaValue);
        setShowLoginButton(false);
        setStatusLogin("Success");
      } else {
        setIsSessionAlreadyLogin(false);
        setCaptchaImageUrl(captchaValue);
        setMessage("");
        setStatusLogin("");
        setShowLoginButton(true);
        setShowCaptcha(true);
      }

      const numbers = res?.phoneNumbers || [];
      if (selectedSchemeName === SchemName.CGHS_NEW && mobileNumber) {
        setPhoneNumbers(numbers.length ? numbers : phoneNumbers);
      } else {
        setPhoneNumbers(numbers);
        if (numbers.length === 1) {
          setMobileNumber(numbers[0]);
        } else {
          setMobileNumber("");
        }
      }

      setIsRetryLoading(false);
      if (res?.message) {
        successMessage(res.message);
      }
    } catch (err: any) {
      errorMessageModal(err?.message || "Please, Try again later");
      setIsRetryLoading(false);
    }
  };

  const Base64Image = ({ base64Data }: { base64Data: string }) => {
    const imageSrc = `data:image/png;base64,${base64Data}`;

    return (
      <img
        src={imageSrc}
        alt="From Base64"
        style={{
          width: "240px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      />
    );
  };

  const LiveScreenBase64Image = ({ base64Data }: { base64Data: string }) => {
    const imageSrc = `data:image/png;base64,${base64Data}`;

    return (
      <img
        src={imageSrc}
        alt="From Base64"
        style={{ width: "100%", borderRadius: "10px" }}
      />
    );
  };

  const handleViewLiveScreen = async () => {
    setIsLiveScreenLoading(true);
    const url = await fetchLiveScreen();
    if (url) {
      setLiveScreenUrl(url);
      setIsLiveScreenModalOpen(true);
    }
    setIsLiveScreenLoading(false);
  };

  const fetchLiveScreen = async () => {
    try {
      if (!selectedHospital || !selectedScheme) {
        warningMessage("Please Select Hospital and Scheme");
        return;
      }
      const data = {
        schemeId: selectedScheme,
        hospitalId: selectedHospital,
        ...(selectedSchemeName === "ECHS" && {
          portalUrl: echsPortalUrlRef.current,
        }),
      };
      const res = await getLiveScreen(data, selectedPortal);
      if (!res?.message || /\s/.test(res.message)) {
        errorMessageModal(
          res?.message ||
            "Not able to fetch live screen at this moment! Please login again!",
        );
        return;
      }
      return res?.message;
    } catch (err: any) {
      errorMessageModal(err?.message);
    }
  };

  const fetchCaptcha = async () => {
    setIsCaptchaLoading(true);
    try {
      if (!selectedHospital || !selectedScheme) {
        warningMessage("Please Select Hospital and Scheme");
        return;
      }

      const data = {
        schemeId: selectedScheme,
        hospitalId: selectedHospital,
        ...(selectedSchemeName === "ECHS" && {
          portalUrl: echsPortalUrlRef.current,
        }),
      };

      const res = await getCaptcha(data, selectedPortal);
      const captchaValue = res?.captcha;
      const isAlreadyLoggedIn =
        typeof captchaValue === "string" &&
        captchaValue.toLowerCase().includes("session is already login");

      if (isAlreadyLoggedIn) {
        setIsSessionAlreadyLogin(true);
        setCaptchaImageUrl(null);
        setCaptchaCodeText1(null);
        setMessage(captchaValue);
        setShowLoginButton(false);
        setStatusLogin("Success");
      } else {
        setIsSessionAlreadyLogin(false);
        setCaptchaImageUrl(captchaValue);
        setMessage("");
        setStatusLogin("");
        setShowLoginButton(true);
      }

      const isMobileNumberRequired =
        selectedSchemeName === SchemName.AYUSHMAN_BHARAT ||
        selectedSchemeName === SchemName.CGHS_NEW;
      const numbers = isMobileNumberRequired ? res?.phoneNumbers || [] : [];
      setPhoneNumbers(numbers);
      if (numbers.length === 1) {
        setMobileNumber(numbers[0]);
      } else {
        setMobileNumber("");
      }
      setIsCaptchaLoading(false);
    } catch (err: any) {
      errorMessageModal(err?.message);
      setIsCaptchaLoading(false);
    }
  };

  const schemeOptions = availableSchemes
    ?.filter((scheme: any) =>
      [SchemName.CGHS_NEW, SchemName.ECHS, SchemName.AYUSHMAN_BHARAT].includes(
        scheme?.schemeMetaDataName?.toUpperCase(),
      ),
    )
    ?.map((scheme: any) => {
      const { portalMetaDataIdsList, ...rest } = scheme;
      return {
        label: getSchemeDisplayName(rest) || rest.schemeMetaDataName,
        value: rest.schemeMetaDataId,
        alternateName: rest.alternateName,
        schemeMetaDataName: rest.schemeMetaDataName,
        portalMetaDataIdsList,
      };
    });

  const handleEchsPortalUrlChange = (value: any) => {
    setEchsPortalUrl(value);
    echsPortalUrlRef.current = value;
    setIsSessionAlreadyLogin(false);
    setShowCaptcha(true);
    fetchCaptcha();
  };

  const onSchemeChange = (
    schemeId: number,
    schemeName: string,
    portalId: any,
  ) => {
    handleSchemeChange(schemeId, schemeName, portalId);
    setFetchPortalDataApiMessage(null);
    setFetchPortalDataApiMessageStatus(null);
    setShowLoginPortal(false);
  };

  const fetchPortalData = async () => {
    try {
      setIsFetchPortalDataLoading(true);
      setFetchPortalDataApiMessage(null);

      if (
        selectedSchemeName === SchemName.ECHS &&
        selectedHospital &&
        selectedScheme
      ) {
        const res = await fetchPortalDataForEchsForEODBOD(
          selectedHospital,
          selectedScheme,
          fetchType,
          initialEODBODConfig?.orchestratorId || -1,
        );
        setFetchPortalDataApiMessage(res?.message);
        setFetchPortalDataApiMessageStatus(res?.status);
        if (res?.id) setFetchActivityId(res.id);
      } else if (
        selectedSchemeName === SchemName.AYUSHMAN_BHARAT &&
        selectedHospital &&
        selectedScheme
      ) {
        const res = await fetchPortalDataForAyushmanBharatForEODBOD(
          selectedHospital,
          selectedScheme,
          fetchType,
          initialEODBODConfig?.orchestratorId || -1,
        );
        setFetchPortalDataApiMessage(res?.message);
        setFetchPortalDataApiMessageStatus(res?.status);
      } else if (selectedHospital && selectedScheme) {
        const res = await fetchPortalDataForCGHSNewForEODBOD(
          selectedHospital,
          selectedScheme,
          fetchType,
          initialEODBODConfig?.orchestratorId || -1,
        );
        setFetchPortalDataApiMessage(res?.message);
        setFetchPortalDataApiMessageStatus(res?.status);
        if (res?.id) setFetchActivityId(res.id);
      }
      getInitialEODBODConfig();
      getProcessHistory(1, processHistoryPagination.pageSize);
    } catch (error: any) {
      setFetchPortalDataApiMessage(
        error?.response?.data?.message || "Failed to fetch data",
      );
      setFetchPortalDataApiMessageStatus("ERROR");
    } finally {
      setIsFetchPortalDataLoading(false);
    }
  };

  const getProcessHistory = async (page: number = 1, size: number = 10) => {
    try {
      if (!selectedHospital) {
        warningMessage("Please Select Hospital");
        return;
      }
      setIsProcessHistoryLoading(true);

      const data: any = {
        hospitalId: selectedHospital,
        page: page - 1,
        size,
      };

      if (fetchType === "all") {
        data.fetchType = "ALL";
      } else if (fetchType === "status") {
        data.fetchType = "STATUS";
      } else if (fetchType === "query") {
        data.fetchType = "QUERY";
      } else if (fetchType === "settlement") {
        data.fetchType = "SETTLEMENT";
      }

      const response = await fetchProcessHistory(data);
      const records = response?.data?.data || [];
      setProcessHistoryData(records);
      setProcessHistoryTotal(response?.data?.totalElements || 0);

      if (records.length > 0 && records[0]?.id) {
        setFetchActivityId(records[0].id);
      }
    } catch (err) {
      setProcessHistoryData([]);
      setProcessHistoryTotal(0);
      errorMessageModal(
        (err as any)?.message || "Failed to load process history",
      );
    } finally {
      setIsProcessHistoryLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedHospital || !fetchActivityId) return;

    const url = `${API_URL}/api/sse/subscribe/eodbodFetchData-${selectedHospital}-${fetchActivityId}`;
    const eventSource = new EventSource(url);

    eventSource.onmessage = (event) => {
      try {
        const status = JSON.parse(event.data);
        if (status) {
          setProcessHistoryData((prevData: any[]) =>
            prevData.map((item) =>
              item?.id === fetchActivityId ? { ...item, status } : item,
            ),
          );
        }
      } catch (error) {
        console.error("Error parsing SSE data:", event?.data);
      }
    };

    eventSource.onerror = (error) => {
      console.error("SSE error:", error);
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, [selectedHospital, fetchActivityId]);

  const renderValue = (value: any) =>
    value === null || value === undefined || value === "" ? "-" : value;

  const onViewMoreClick = () => {
    handleViewMoreClick();
  };

  const handleLoginHistoryModalPaginationChange = (
    page: number,
    size: number,
  ) => {
    const payload = {
      hospitalId: selectedHospital,
      schemeId: selectedScheme,
      page: page - 1,
      size,
    };

    fetchLoginHistoryModalData(payload);
  };

  const onViewLoginHistoryClicked = () => {
    setOpenLoginHistoryModal(true);
    const payload = {
      hospitalId: selectedHospital,
      schemeId: selectedScheme,
      page: 0,
      size: 100,
    };

    fetchLoginHistoryModalData(payload);
  };

  const fetchLoginHistoryModalData = async (payload: any) => {
    try {
      setIsLoginHistoryModalDataLoading(true);
      const response = await fetchLoginHistory(payload);
      setloginHistoryModalData(response?.data?.data || []);
      setLoginHistoryDataTotal(response?.data?.totalElements || 0);
    } catch (error: any) {
      const messageText =
        error?.message || "Failed to load process history for View More";
      errorMessageModal(messageText);
      setloginHistoryModalData([]);
      setLoginHistoryDataTotal(0);
    } finally {
      setIsLoginHistoryModalDataLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <Card
        title={
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <AppstoreOutlined style={{ color: "rgb(0, 76, 143)" }} />
            Scheme Selection
          </span>
        }
        extra={
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <a onClick={() => onViewLoginHistoryClicked()}>
              View Login History
            </a>
          </div>
        }
      >
        <Row gutter={12}>
          {schemeOptions.map((item: any) => (
            <Col span={4} key={item.value}>
              <Card
                hoverable
                onClick={() =>
                  onSchemeChange(
                    item?.value,
                    item?.schemeMetaDataName || item?.label,
                    item.portalMetaDataIdsList?.[0],
                  )
                }
                style={{
                  textAlign: "center",
                  padding: "6px",
                  height: "45px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border:
                    selectedScheme === item.value
                      ? "2px solid rgb(0, 76, 143)"
                      : "1px solid #e5e5e5",
                  background:
                    selectedScheme === item.value ? "#f0f6ff" : "#fff",
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              >
                <Text strong>{getSchemeDisplayName(item) || item.label}</Text>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>

      {selectedScheme &&
        (isLastLoginHistoryLoading || lastLoginHistoryData?.length > 0) && (
          <Spin spinning={isLastLoginHistoryLoading}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                padding: "4px 0",
              }}
            >
              {lastLoginHistoryData?.map((record: any, index: number) => {
                const schemeLabel =
                  getSchemeDisplayName(record) || record?.schemeName || "-";
                const loginDate = record?.loginTime
                  ? dayjs.utc(record.loginTime).local().format("DD-MMM-YYYY")
                  : "-";
                const loginTime = record?.loginTime
                  ? dayjs.utc(record.loginTime).local().format("hh:mm A")
                  : "-";
                const mobilePart = record?.mobileNumber
                  ? ` with mobile no ${record.mobileNumber}`
                  : "";

                return (
                  <div
                    key={record?.schemeId || record?.id || index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      flexWrap: "wrap",
                    }}
                  >
                    <Text>
                      <Text strong>{schemeLabel}</Text>
                      {" Portal was last "}
                      <Text strong>logged in</Text>
                      {" by "}
                      <Text strong>{record?.createdByName || "-"}</Text>
                      {" on "}
                      <Text strong>{loginDate}</Text>
                      {" at "}
                      <Text strong>{loginTime}</Text>
                      {`${mobilePart} - `}
                    </Text>
                    <Tag
                      style={{
                        backgroundColor: `${
                          record?.isCurrentlyLoggedIn === true
                            ? "#2E8B57"
                            : record?.isCurrentlyLoggedIn === false
                              ? "#D51E1E"
                              : "#A6A6A6"
                        }22`,
                        color:
                          record?.isCurrentlyLoggedIn === true
                            ? "#2E8B57"
                            : record?.isCurrentlyLoggedIn === false
                              ? "#D51E1E"
                              : "#A6A6A6",
                        borderRadius: "24px",
                        padding: "4px 10px",
                        fontWeight: 700,
                        fontSize: "0.8rem",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        margin: 0,
                        cursor: "default",
                        boxShadow: "0px -3px 4px 0px #00000040 inset",
                      }}
                    >
                      <span
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          backgroundColor:
                            record?.isCurrentlyLoggedIn === true
                              ? "#2E8B57"
                              : record?.isCurrentlyLoggedIn === false
                                ? "#D51E1E"
                                : "#A6A6A6",
                          display: "inline-block",
                        }}
                      />
                      {record?.isCurrentlyLoggedIn === true
                        ? "Portal: Active"
                        : record?.isCurrentlyLoggedIn === false
                          ? "Portal: Inactive"
                          : "Portal: Unknown"}
                    </Tag>
                  </div>
                );
              })}
            </div>
          </Spin>
        )}

      {selectedScheme && !showLoginPortal && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            gap: 12,
            alignItems: "center",
          }}
        >
          <Button
            type="primary"
            icon={<LoginOutlined />}
            style={{
              backgroundColor: "#004C8F",
              color: "#fff",
              borderRadius: "8px",
              padding: "6px 14px",
              fontWeight: 600,
            }}
            onClick={() => {
              setShowLoginPortal(true);
              if (
                selectedSchemeName === SchemName.AYUSHMAN_BHARAT ||
                selectedSchemeName === SchemName.CGHS_NEW
              ) {
                setShowCaptcha(true);
                fetchCaptcha();
              }
            }}
          >
            Proceed to Login
          </Button>
          <Button
            type="default"
            loading={isLiveScreenLoading}
            disabled={isLiveScreenLoading}
            style={{
              color: "#FFFFFF",
              backgroundColor: "#004C8F",
              borderRadius: "8px",
              padding: "6px 14px",
              fontWeight: 600,
            }}
            onClick={handleViewLiveScreen}
          >
            View Live Screen
          </Button>
        </div>
      )}

      {selectedScheme && showLoginPortal && (
        <Card
          title={
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <LockOutlined style={{ color: "rgb(0, 76, 143)" }} />
              {selectedSchemeName} Login Portal
            </span>
          }
        >
          {selectedSchemeName === SchemName.ECHS && (
            <div style={{ marginBottom: 20 }}>
              <Text
                strong
                style={{ fontSize: 14, display: "block", marginBottom: 8 }}
              >
                ECHS Portal URL
              </Text>
              <Radio.Group
                style={{ display: "flex", gap: 16 }}
                value={echsPortalUrl}
                onChange={(e) => handleEchsPortalUrlChange(e.target.value)}
              >
                <Radio
                  value="https://www.echsbpa.utiitsl.com/ECHS/"
                  style={{ color: "#374151" }}
                  disabled={
                    (showCaptcha &&
                      captchaImageUrl &&
                      echsPortalUrl !==
                        "https://www.echsbpa.utiitsl.com/ECHS/") ||
                    (isSessionAlreadyLogin &&
                      echsPortalUrl !== "https://www.echsbpa.utiitsl.com/ECHS/")
                  }
                >
                  <span style={{ fontWeight: 600, color: "#374151" }}>
                    MAIN URL (https://www.echsbpa.utiitsl.com/ECHS/)
                  </span>
                </Radio>
                <Radio
                  value="https://www.echsbpa1.utiitsl.com/ECHS/"
                  style={{ color: "#374151" }}
                  disabled={
                    (showCaptcha &&
                      captchaImageUrl &&
                      echsPortalUrl !==
                        "https://www.echsbpa1.utiitsl.com/ECHS/") ||
                    (isSessionAlreadyLogin &&
                      echsPortalUrl !==
                        "https://www.echsbpa1.utiitsl.com/ECHS/")
                  }
                >
                  <span style={{ fontWeight: 600, color: "#374151" }}>
                    ALTERNATE URL (https://www.echsbpa1.utiitsl.com/ECHS/)
                  </span>
                </Radio>
              </Radio.Group>
            </div>
          )}

          <Spin spinning={isCaptchaLoading} tip="Loading Captcha...">
            <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 20 }}>
              {(selectedSchemeName === SchemName.AYUSHMAN_BHARAT ||
                selectedSchemeName === SchemName.CGHS_NEW) &&
                showCaptcha &&
                phoneNumbers.length > 0 && (
                  <div style={{ marginBottom: 20 }}>
                    <Text
                      strong
                      style={{
                        fontSize: "14px",
                        color: "#1F2937",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Mobile Number
                    </Text>
                    <Select
                      showSearch
                      placeholder="Select a Mobile Number"
                      value={mobileNumber || undefined}
                      optionFilterProp="label"
                      style={{ width: "100%", marginTop: "0.8rem" }}
                      options={phoneNumbers.map((phone) => ({
                        label: phone,
                        value: phone,
                      }))}
                      onChange={(value) => {
                        handleMobileChange(value);
                      }}
                    />
                  </div>
                )}

              {isSessionAlreadyLogin ? (
                <Col>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 12,
                      padding: "8px 0",
                    }}
                  >
                    <Text
                      style={{
                        color: "green",
                        fontWeight: 600,
                        fontSize: 15,
                      }}
                    >
                      {message || "Session is already login"}
                    </Text>
                    <Button
                      type="default"
                      style={{
                        backgroundColor: "#D51E1E",
                        color: "white",
                        borderRadius: "8px",
                        padding: "6px 14px",
                        fontWeight: 600,
                      }}
                      onClick={handleLogout}
                      loading={isLoggedOutLoading}
                    >
                      Log Out
                    </Button>
                  </div>
                </Col>
              ) : (
                showCaptcha && (
                  <>
                    {/* Captcha 1 */}
                    <Col>
                      {captchaImageUrl && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          {selectedSchemeName === SchemName.ECHS && (
                            <SyncOutlined
                              title="Refresh Captcha"
                              onClick={fetchCaptcha}
                              style={{ cursor: "pointer" }}
                            />
                          )}

                          <Base64Image base64Data={captchaImageUrl} />

                          <Input
                            placeholder="Enter Captcha"
                            value={captchaCodeText1}
                            onChange={(e) =>
                              setCaptchaCodeText1(e.target.value)
                            }
                            style={{ width: 140, textTransform: "none" }}
                          />
                        </div>
                      )}
                    </Col>

                    {/* Captcha 2 (same condition, no change) */}
                    {showOtpField && (
                      <>
                        {(selectedSchemeName === SchemName.AYUSHMAN_BHARAT ||
                          selectedSchemeName === SchemName.CGHS_NEW) &&
                          captchaImageUrl2 && (
                            <Col>
                              <Spin
                                spinning={isCaptchaLoading}
                                tip="Loading Captcha..."
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                  }}
                                >
                                  <Base64Image base64Data={captchaImageUrl2} />

                                  <Input
                                    placeholder="Enter Captcha"
                                    value={captchaCodeText2}
                                    onChange={(e) =>
                                      setCaptchaCodeText2(e.target.value)
                                    }
                                    style={{
                                      width: 140,
                                      textTransform: "none",
                                    }}
                                  />
                                </div>
                              </Spin>
                            </Col>
                          )}

                        {/* OTP + Button (same logic) */}
                        <Col style={{ marginTop: 16 }}>
                          <Form form={form} layout="inline" onFinish={onFinish}>
                            <Form.Item
                              label={
                                <span
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "16px",
                                  }}
                                >
                                  OTP
                                </span>
                              }
                              name="otp"
                              rules={[
                                { required: true, message: "OTP is required" },
                              ]}
                            >
                              <Input
                                placeholder="Enter OTP"
                                style={{ width: 160 }}
                              />
                            </Form.Item>

                            <Form.Item>
                              <Button
                                type="primary"
                                loading={isOtpLoading}
                                htmlType="submit"
                                style={{
                                  color: "#FFFFFF",
                                  backgroundColor: "#008B8B",
                                  fontWeight: 700,
                                  borderRadius: "8px",
                                  padding: "0 20px",
                                }}
                              >
                                Submit
                              </Button>
                            </Form.Item>
                          </Form>
                        </Col>
                      </>
                    )}
                  </>
                )
              )}
            </Row>
          </Spin>

          {message && !isSessionAlreadyLogin && (
            <div style={{ width: "100%", marginTop: "4px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    color:
                      statusLogin?.toLowerCase()?.includes("failed") ||
                      statusLogin?.toLowerCase()?.includes("reject")
                        ? "red"
                        : "green",
                    fontWeight: 600,
                  }}
                >
                  {message}
                </Text>
              </div>
            </div>
          )}

          <div
            style={{
              width: "100%",
              display: "flex",
              gap: "12px",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <Button
              type="default"
              loading={isLiveScreenLoading}
              disabled={isLiveScreenLoading}
              style={{
                color: "#FFFFFF",
                backgroundColor: "#004C8F",
                borderRadius: "8px",
                padding: "6px 14px",
                fontWeight: 600,
              }}
              onClick={handleViewLiveScreen}
            >
              View Live Screen
            </Button>

            {!isSessionAlreadyLogin && showCaptcha ? (
              selectedHospital &&
              selectedScheme &&
              showLoginButton &&
              captchaCodeText1 ? (
                <Col>
                  <Button
                    icon={<LoginOutlined />}
                    style={{ backgroundColor: "#004C8F", color: "#fff" }}
                    onClick={handleSaveLogin}
                    loading={isLoggedInLoading}
                  >
                    {(selectedSchemeName === SchemName.AYUSHMAN_BHARAT ||
                      selectedSchemeName === SchemName.CGHS_NEW) &&
                    !showOtpField
                      ? "Verify"
                      : "Login"}
                  </Button>
                </Col>
              ) : (
                <></>
              )
            ) : !isSessionAlreadyLogin &&
              selectedHospital &&
              selectedScheme &&
              showLoginButton &&
              selectedSchemeName !== SchemName.ECHS &&
              !isLoggedOut ? (
              <Col>
                <Button
                  icon={<LoginOutlined />}
                  style={{ backgroundColor: "#004C8F", color: "#fff" }}
                  onClick={handleSaveLogin}
                  loading={isLoggedInLoading}
                >
                  {(selectedSchemeName === SchemName.AYUSHMAN_BHARAT ||
                    selectedSchemeName === SchemName.CGHS_NEW) &&
                  !showOtpField
                    ? "Verify"
                    : "Login"}
                </Button>
              </Col>
            ) : (
              <></>
            )}

            {!isSessionAlreadyLogin &&
              !showLoginButton &&
              !statusLogin?.toLowerCase()?.includes("failed") &&
              !statusLogin?.toLowerCase()?.includes("reject") && (
                <Button
                  type="default"
                  style={{
                    backgroundColor: "#D51E1E",
                    color: "white",
                    borderRadius: "8px",
                    padding: "6px 14px",
                    fontWeight: 600,
                  }}
                  onClick={handleLogout}
                  loading={isLoggedOutLoading}
                >
                  Log Out
                </Button>
              )}

            {statusLogin?.toLowerCase()?.includes("failed") ||
            statusLogin?.toLowerCase()?.includes("reject")
              ? !(
                  selectedSchemeName === SchemName.AYUSHMAN_BHARAT ||
                  selectedSchemeName === SchemName.CGHS_NEW
                ) && (
                  <Button
                    type="default"
                    style={{
                      color: "white",
                      backgroundColor: "#D51E1E",
                      borderRadius: "8px",
                      padding: "6px 14px",
                      fontWeight: 600,
                    }}
                    onClick={handleLogout}
                  >
                    Retry
                  </Button>
                )
              : null}

            {selectedSchemeName === SchemName.CGHS_NEW &&
              selectedHospital &&
              selectedHospital !== -1 &&
              selectedScheme && (
                <Button
                  type="default"
                  loading={isRetryLoading}
                  disabled={isRetryLoading}
                  style={{
                    color: "white",
                    backgroundColor: "#52C41A",
                    borderColor: "#52C41A",
                    borderRadius: "8px",
                    padding: "6px 14px",
                    fontWeight: 600,
                  }}
                  onClick={handleLoginRetry}
                >
                  Retry
                </Button>
              )}
          </div>
        </Card>
      )}

      {/* Fetch Actions */}
      <Card
        title={
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <SwapOutlined style={{ color: "rgb(0, 76, 143)" }} />
            Fetch Actions
          </span>
        }
      >
        <Row gutter={10}>
          {[
            { label: "Settlement", value: "settlement" },
            { label: "Query", value: "query" },
            { label: "Status", value: "status" },
            { label: "All", value: "all" },
          ].map((item) => (
            <Col span={3} key={item.value}>
              <Card
                hoverable={item.value === "all"}
                onClick={() => item.value === "all" && setFetchType(item.value)}
                style={{
                  textAlign: "center",
                  padding: "4px",
                  height: "38px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border:
                    fetchType === item.value
                      ? "2px solid rgb(0, 76, 143)"
                      : "1px solid #d9d9d9",
                  background: fetchType === item.value ? "#f0f6ff" : "#f5f5f5",
                  cursor: fetchType === item.value ? "pointer" : "not-allowed",
                  fontSize: "12px",
                  opacity: fetchType === item.value ? 1 : 0.6,
                }}
              >
                <Text strong>{item.label}</Text>
              </Card>
            </Col>
          ))}
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col>
            <div style={{ display: "flex", alignItems: "center", gap: 40 }}>
              <Button
                icon={<DownloadOutlined />}
                style={{ backgroundColor: "#004C8F", color: "#fff" }}
                loading={isFetchPortalDataLoading}
                disabled={!selectedHospital || !selectedScheme}
                onClick={fetchPortalData}
              >
                Fetch Data
              </Button>

              {fetchPortalDataApiMessage && (
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  {fetchPortalDataApiMessageStatus?.toUpperCase() ===
                  "SUCCESS" ? (
                    <CheckCircleOutlined style={{ color: "#52c41a" }} />
                  ) : (
                    <CloseCircleOutlined style={{ color: "#ff4d4f" }} />
                  )}

                  <Typography.Text
                    style={{
                      color:
                        fetchPortalDataApiMessageStatus?.toUpperCase() ===
                        "SUCCESS"
                          ? "#52c41a"
                          : "#ff4d4f",
                      fontWeight: 500,
                    }}
                  >
                    {fetchPortalDataApiMessage}
                  </Typography.Text>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Card>

      <Card
        title="Process History"
        extra={
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Tooltip title="Refresh data">
              <Button
                icon={<ReloadOutlined />}
                size="small"
                style={{
                  borderRadius: "7px",
                  padding: "6px 14px",
                  fontWeight: 500,
                  color: "#00549D",
                  cursor: "pointer",
                  textDecoration: "none",
                }}
                onClick={onRefreshClick}
                loading={isRefreshLoading}
              >
                Refresh
              </Button>
            </Tooltip>

            <a onClick={() => onViewMoreClick()}>View More</a>
          </div>
        }
      >
        <>
          <Table
            loading={isProcessHistoryLoading}
            dataSource={processHistoryData}
            columns={[
              {
                title: "Scheme",
                dataIndex: "schemeName",
                render: (text: string | null, record: any) =>
                  text ? (
                    getSchemeDisplayName(record) || text
                  ) : (
                    <Text type="secondary">-</Text>
                  ),
              },
              {
                title: "Fetch Actions",
                dataIndex: "fetchType",
                render: renderValue,
              },
              {
                title: "Initiated By",
                dataIndex: "performedByName",
                render: renderValue,
              },
              {
                title: "Timestamp",
                dataIndex: "executedAt",
                render: (_: any, record: any) => {
                  return record?.executedAt
                    ? dayjs
                        .utc(record.executedAt)
                        .local()
                        .format("DD-MM-YYYY hh:mm A")
                    : "-";
                },
              },
              {
                title: "Status",
                dataIndex: "status",
                render: (status: string) => (
                  <Tag
                    color={
                      status?.toLowerCase() === "success" ? "green" : "orange"
                    }
                    style={{
                      borderRadius: "999px",
                      padding: "2px 12px",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <Badge
                      color={
                        status?.toLowerCase() === "success" ? "green" : "orange"
                      }
                    />
                    {status ?? "-"}
                  </Tag>
                ),
              },
              {
                title: "Progressive Status",
                dataIndex: "progressiveStatus",
                render: (value: string | number) => {
                  return (
                    <Progress
                      type="circle"
                      percent={Number(value)}
                      size={50}
                      strokeColor="#52c41a"
                      format={() => `${value}%`}
                    />
                  );
                },
              },
              {
                title: "Summary",
                render: (_: any, record: any) => {
                  const isSummaryBtnDisabled =
                    record?.status?.toLowerCase() === "success"
                      ? false
                      : Number(record?.progressiveStatus) === 0;

                  return (
                    <Flex gap={8}>
                      <span
                        style={{
                          color: isSummaryBtnDisabled ? "#bfbfbf" : "#00549D",
                          cursor: isSummaryBtnDisabled
                            ? "not-allowed"
                            : "pointer",
                        }}
                      >
                        <a
                          onClick={() => {
                            if (isSummaryBtnDisabled) return;
                            handleSummaryClicked(record);
                          }}
                          style={{
                            pointerEvents: isSummaryBtnDisabled
                              ? "none"
                              : "auto",
                            color: "inherit",
                            textDecoration: "none",
                          }}
                        >
                          Summary
                        </a>
                      </span>
                    </Flex>
                  );
                },
              },
            ]}
            pagination={{
              current: processHistoryPagination.current,
              pageSize: processHistoryPagination.pageSize,
              total: processHistoryTotal,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              onChange: (page, pageSize) => {
                setProcessHistoryPagination({ current: page, pageSize });
                getProcessHistory(page, pageSize);
              },
            }}
            rowClassName={(record, index) =>
              index % 2 === 0 ? "ant-table-row-light" : ""
            }
          />
        </>
      </Card>

      <Modal
        title="Live Screen"
        open={isLiveScreenModalOpen}
        footer={null}
        onCancel={() => setIsLiveScreenModalOpen(false)}
        width={1000}
      >
        {liveScreenUrl ? (
          selectedSchemeName === SchemName.ECHS ||
          selectedSchemeName === SchemName.CGHS_NEW ||
          selectedSchemeName === SchemName.AYUSHMAN_BHARAT ? (
            <LiveScreenBase64Image base64Data={liveScreenUrl} />
          ) : (
            <img
              src={liveScreenUrl}
              alt="Live Screen"
              style={{ width: "100%", borderRadius: "10px" }}
            />
          )
        ) : (
          <p>No Live Screen Available</p>
        )}
      </Modal>

      <LoginHistoryModal
        open={openLoginHistoryModal}
        onClose={() => setOpenLoginHistoryModal(false)}
        isLoginHistoryModalDataLoading={isLoginHistoryModalDataLoading}
        loginHistoryModalData={loginHistoryModalData}
        loginHistoryDataTotal={loginHistoryDataTotal}
        onPaginationChange={handleLoginHistoryModalPaginationChange}
      />
    </div>
  );
};

export default FetchSchemeActions;
